<template>
  <div class="background">
    <div class="container">
      <div class="drone"></div>
      <div class="error-title">Something went wrong</div>
      <div class="error-text">{{errorText}}</div>
      <div class="email-link">
        If you continue to experience technical difficulties with the page you are trying to reach please contact
        <a class="link" href="mailto:hello@cryptoalerts.com?subject=Server%20error">
          <red-text>hello@cryptoalerts.com</red-text> <!-- TODO change to correct email -->
        </a>.
      </div>
      <div class="navigation-links">
        <template v-if="showReloginBlock">
          Please try to
          <red-text class="red-text_link" @click.native="openLoginModal">Relogin</red-text>
        </template>
        <template v-else>
          You can report this error at
          <router-link class="link" to="/support">
            <red-text>Support Page</red-text>
          </router-link>
        </template>
        or keep working at
        <router-link class="link" to="/all-currencies">
          <red-text>All Currencies Page</red-text>
        </router-link>.
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loginModalTabs from 'src/models/LoginModalTabs';

export default {
  props: {
    needRelogin: Boolean,
    errorText: String,
  },
  created() {

  },
  computed: {
    ...mapState('userData', ['loginInfo']),
    showReloginBlock() {
      return this.needRelogin && !this.loginInfo;
    },
  },
  methods: {
    ...mapActions('settings', [
      'toggleLoginModal',
    ]),
    openLoginModal() {
      this.toggleLoginModal({ val: true, activeTab: loginModalTabs.login });
    },
  },
};
</script>

<style lang="scss" scoped>
.background {
  @include background(0);
  display: flex;
}
.container {
  margin: auto;
  text-align: center;
  width: 613px;
}
.red-text {
  &_link {
    cursor: pointer;
  }
  display: inline-block;
}
.link {
  text-decoration: none;
}
.drone {
  @include attachImage('drone-confused', 110px, 170px);
  margin: auto;
}
.error-title {
  @include font(30px, $black-color1, 500);
  margin-top: 44px;
}
.error-text {
  margin-top: 30px;
  line-height: 21px;
}
.email-link {
  margin-top: 33px;
  line-height: 21px;
}
.navigation-links {
  margin-top: 24px;
}
</style>




// WEBPACK FOOTER //
// src/components/pages/ServerError.vue